/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-07-15 14:33:24
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-09-03 14:37:20
 * @FilePath: \member_ship\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import regist from '../views/regist.vue'
import changeData from '../views/changeData.vue'
import addswap from '../views/addswap.vue'
import details from '../views/details.vue'
import Contacts from '../views/Contacts.vue'
import newspage from '../views/newspage.vue'
import introduce from '../views/introduce.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'regist',
    meta: { title: '会员登记' },
    component: regist
  },
  {
    path: '/swap',
    name: 'changeData',
    meta: { title: '发布供需' },
    component: changeData
  },
  {
    path: '/introduce',
    name: 'introduce',
    meta: { title: '商会介绍' },
    component: introduce
  },
  {
    path: '/newspage',
    name: 'newspage',
    meta: { title: '新闻动态' },
    component: newspage
  },
  {
    path: '/addswap',
    name: 'addswap',
    meta: { title: '发布供需' },
    component: addswap
  },
  {
    path: '/details',
    name: 'details',
    meta: { title: '发布供需' },
    component: details
  },
  {
    path: '/Contacts',
    name: 'Contacts',
    meta: { title: '会员通讯录' },
    component: Contacts
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
  document.title = to.meta.title;
  }
  next();
  });
export default router
